import React, { useEffect, useState, useImperativeHandle, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";

import "./custom.scss";

import "./styles.scss";
import { initialData_qc as initialData } from "./TableDataSet";

import update from "immutability-helper";

import Rows from "./DnDTables/DataTable";

const P_TYPE = "qc";
const API = "";

const HeaderTarget = {
    qcReceivingSite: "Receiving Site",
    qcSendingSite: "Sending Site",
    qcAlertLimit: "Alert Limit",
    qcActionLimit: "Action Limit",
    qcAcceptanceLimit: "Acceptance Limit",
};

const QCTable = (props, _ref) => {
    const { so, sso, PROCode, autoResizeTextarea,onOpen,RevCmptCheckList } = props;

    const [Hide, setHide] = useState(false);
    const [TData, setTData] = useState([]);

    const [Header, SetHeader] = useState(HeaderTarget);
    const [temp, setTemp] = useState([]);

    useImperativeHandle(_ref, () => ({
        getTableData: () => {
            return TData;
        },
        loadData: ({ data, header }) => {
            let newVal = [];
            let tmparr;
            let tmp;
            let fidx;
            data.forEach((d) => {
                tmp = initialData;
                tmparr = [];
                d.forEach((dd) => {
                    Object.keys(dd).forEach((k) => {
                        fidx = tmp.findIndex((i) => i.name === k);
                        if (fidx > -1)
                            tmp = update(tmp, {
                                [fidx]: { $merge: { value: dd[k] } },
                            });
                        if (k === "samplePoint") {
                            tmp = update(tmp, {
                                [fidx]: {
                                    $merge: { label: dd["samplePointNm"] },
                                },
                            });
                        }
                    });

                    tmparr = [...tmparr, ...[tmp]];
                });

                newVal = [...newVal, [...tmparr]];
            });
            setTData((DATA) => [...newVal]);
            setTemp((DATA) => [...newVal]);
            SetHeader((d) => {
                let newData = {};
                Object.keys(HeaderTarget).forEach((i) => {
                    newData[i] = !!header?.[i] ? header?.[i] : HeaderTarget?.[i];
                });
                return newData;
            });
        },
        preOnData: ({data}) =>{
            setTData(data);
        },
        resetData: () =>{
            setTData(temp);
        },
    }));

    const onOpenWrapper = (vv,uniqueCode) => {
        onOpen(vv,uniqueCode,TData,'QC');
    }

    useEffect(() => {
        document.querySelectorAll("textarea").forEach((e) => {
            autoResizeTextarea(e);
        });
    }, [TData]);

    const renderFunc = useMemo(() => {
        try {
            let _sso;
            if (sso > 0) {
                _sso = so[sso];
                let remark = _sso[P_TYPE + "Remark"];
                return (
                    <React.Fragment>
                        <tr>
                            <td colSpan={Object.keys(initialData).length - 1} className="name">
                                <div className={"namename"}>
                                    {_sso?.desc}
                                    {/* <div className={"code"}>{"(" + _sso?.seqCode + ")"}</div> */}
                                </div>
                            </td>
                        </tr>
                        {remark !== "FALSE" && (
                            <tr>
                                <td
                                    colSpan={Object.keys(initialData).length - 1}
                                    className="soremark"
                                >
                                    <div>{remark}</div>
                                </td>
                            </tr>
                        )}
                        {TData[sso - 1].map((v, ii) => {
                            return (
                                <Rows
                                    api={API}
                                    code={_sso.code}
                                    PROCode={PROCode}
                                    index={ii}
                                    rowData={v}
                                    autoResizeTextarea={autoResizeTextarea}
                                    key={"qc" + ii}
                                    onOpen = {onOpenWrapper}
                                    sheetType={"Q"}
                                    RevCmptCheckList={RevCmptCheckList}
                                />
                            );
                        })}
                    </React.Fragment>
                );
            } else {
                const ret = so.map((k, i) => {
                    if (!!!k.code) {
                        return null;
                    }
                    try {
                        let chk = TData[i - 1].filter((v) => {
                            let chk2 = v.find((c) => c.name === "hide");
                            return chk2.value !== "TRUE";
                        });
                        let remark = k[P_TYPE + "Remark"];

                        if (chk.length > 0) {
                            return (
                                <React.Fragment key={i}>
                                    <tr>
                                        <td
                                            colSpan={Object.keys(initialData).length - 2}
                                            className="name"
                                        >
                                            <div className={"namename"}>
                                                {k.desc}
                                                {/* <div className={"code"}>
                                                    {"(" + k.seqCode + ")"}
                                                </div> */}
                                            </div>
                                        </td>
                                    </tr>
                                    {remark !== "FALSE" && (
                                        <tr>
                                            <td
                                                colSpan={Object.keys(initialData).length - 2}
                                                className="soremark"
                                            >
                                                <div>{remark}</div>
                                            </td>
                                        </tr>
                                    )}
                                    {TData[i - 1].map((v, ii) => {
                                        return (
                                            <Rows
                                                api={API}
                                                PROCode={PROCode}
                                                code={k.code}
                                                index={ii}
                                                rowData={v}
                                                autoResizeTextarea={autoResizeTextarea}
                                                key={"out" + ii}
                                                onOpen = {onOpenWrapper}
                                                dataIndex={i}
                                                sheetType={"Q"}
                                                RevCmptCheckList={RevCmptCheckList}
                                            />
                                        );
                                    })}
                                </React.Fragment>
                            );
                        } else {
                            return null;
                        }
                    } catch (e) {
                        return null;
                    }
                });
                return ret;
            }
        } catch (e) {
            return null;
        }
    }, [TData, so, sso]);

    const HandleHide = () => {
        setHide(!Hide);
    };

    return (
        <section className="detail">
            <div className={"in_table tbl_box " + (Hide ? "hide" : "")}>
                <h1 className={"title "} onClick={HandleHide}>
                    {P_TYPE.toUpperCase()} <FontAwesomeIcon icon={faAngleUp} />
                </h1>
                <div className={"data_table "}>
                    <table>
                        <colgroup>
                            <col width="2%"></col>
                            <col width="3%"></col>
                            <col width="6%"></col>
                            <col width="4%"></col>
                            <col width="4%"></col>
                            <col width="4%"></col>
                            <col width="4%"></col>
                            <col width="5%"></col>
                            <col width="2%"></col>
                            <col width="3%"></col>
                            <col width="2%"></col>
                            <col width="3%"></col>
                            <col width="2%"></col>
                            <col width="3%"></col>
                            <col width="2%"></col>
                            <col width="3%"></col>
                            <col width="2%"></col>
                            <col width="3%"></col>
                            <col width="5%"></col>
                            <col width="2%"></col>
                            <col width="3%"></col>
                            <col width="2%"></col>
                            <col width="3%"></col>
                            <col width="2%"></col>
                            <col width="3%"></col>
                            <col width="2%"></col>
                            <col width="3%"></col>
                            <col width="2%"></col>
                            <col width="3%"></col>
                            <col width="7%"></col>
                        </colgroup>
                        <thead>
                            <tr>
                                <th rowSpan="3"></th>
                                <th rowSpan="3">Parameter Code</th>
                                <th rowSpan="3">Sample Point</th>
                                <th rowSpan="3">Day / Cycle</th>
                                <th rowSpan="3">Parameter</th>
                                <th rowSpan="3">Test Method</th>
                                <th rowSpan="3">Unit</th>
                                <th colSpan="11">{Header.qcReceivingSite}</th>
                                <th colSpan="11">{Header.qcSendingSite}</th>
                                <th rowSpan="5">Reference</th>
                            </tr>

                            <tr>
                                <th colSpan="1" rowSpan="2">
                                    Criticality
                                </th>
                                <th colSpan="4">Alert Limit</th>
                                <th colSpan="4">Action Limit</th>
                                <th colSpan="2" rowSpan="2">
                                    Acceptance Limit
                                </th>
                                <th colSpan="1" rowSpan="2">
                                    Criticality
                                </th>
                                <th colSpan="4">{Header.qcAlertLimit}</th>
                                <th colSpan="4">{Header.qcActionLimit}</th>
                                <th colSpan="2" rowSpan="2">
                                    {Header.qcAcceptanceLimit}
                                </th>
                            </tr>

                            <tr>
                                <th colSpan="2">Min</th>
                                <th colSpan="2">Max</th>
                                <th colSpan="2">Min</th>
                                <th colSpan="2">Max</th>
                                <th colSpan="2">Min</th>
                                <th colSpan="2">Max</th>
                                <th colSpan="2">Min</th>
                                <th colSpan="2">Max</th>
                                {/* <th colSpan="2">Min</th>
                                <th colSpan="2">Max</th> */}
                            </tr>
                        </thead>
                        <tbody>{renderFunc}</tbody>
                    </table>
                </div>
            </div>
        </section>
    );
};

export default React.memo(React.forwardRef(QCTable));
